// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.page {
    margin: 0 var(--space-x3);
    display: grid;
    grid-template-areas: ". left left left center center center center center center center . ";
    grid-template-columns: repeat(12, 1fr);
    gap: var(--space-and-half);
    padding-bottom: var(--space-x3);
}

.page-admin__content{
    /* width: 85%; */
    margin: 0 auto;
}

.page-title {
    position: absolute;
    margin-top: var(--space-x2-and-half);
    margin-left: calc((calc((calc((calc(100% - (calc(var(--space-x3)*2)) - (calc(11* var(--space-and-half)))))/12)) *2)) + var(--space-x3));;
}

.page__left-container {
    grid-area: left;
}

.page__left-container__info {
    margin: var(--space-x2-and-half) 0;
}

/* .page__right-container {
    margin-top: var(--space-x2-and-half);
    grid-area: right;
    grid-column-start: 10;
    grid-column-end: 13;
} 

.page__right-container.adminview {
    display: none;
}
.page__right-container__title {
    margin-top: var(--space-x3);
}
.page__right-container__subtitle {
    margin-top: var(--space-x2);
}
.page__right-container__profile-suggestions {
    margin-top: var(--space-x2);
}
.page__right-container__pages-suggestions {
    margin-top: var(--space-x2);
} */

.page__center-container {
    grid-area: center;
    grid-column-start: 2;
    grid-column-end: 12;
}

.page__center-container.unauth {
    grid-column-start: 3;
    grid-column-end: 11;
}

.page__center-container.adminview {
    grid-column-start: 3;
    grid-column-end: 13;
}
.page__center-container__info-horizontal {
    margin-top: calc(var(--space-x2-and-half));
}
.page__center-container__tabs {
    background-color: var(--white-color);
    border-top: 1px solid var(--new-gray-background-color);
    border-bottom: 1px solid var(--new-gray-background-color);
}

.page__center-container__tabs .MuiTabs-flexContainer{
    border-bottom: unset;
}

.page__center-container__tabs .MuiTab-wrapper {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + 1px);/*17px*/
    line-height: calc(var(--space) + var(--space-quarter));/* 20px */
    letter-spacing: 0.005em;
    color: var(--primary-dark-color);
    text-transform: none;
}


.page__center-container__tabs .MuiTabs-flexContainer .MuiButtonBase-root {
    min-width: 100px;
}

.page__completion {
    margin-top: var(--space-and-half);
}
.page__basic-info {
    /* margin-top: var(--space-and-half); */
}
.page__technics {
    margin-top: var(--space-and-half);
}
.page__skills {
    margin-top: var(--space-and-half);
}
.page__experiences {
    /* margin-top: var(--space-and-half); */
}
.page__aptitudes {
    margin-top: var(--space-and-half);
}

.page_tab_feed{
    width: 60%;
    margin-left: auto;
    margin-right: auto;
}

.page__private-message {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70%;
    text-align: center;
}
.page__private-message__icon {
    margin-top: var(--space-x3);
    color: var(--basic-gray-color);
    font-size: var(--space-x2-and-half);
}
p.page__private-message__title {
    margin-top: var(--space-half);
    color: var(--basic-gray-color) !important;
}
p.page__private-message__subtitle {
    margin-top: var(--space-half);
    color: var(--basic-gray-color) !important;
}


@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .page {
        margin: var(--space-and-half) 0 0 0;
        grid-template-areas: "left" "center";
        grid-template-columns: 100%;
        gap: var(--space-half);
    }
    .page-admin__content {
        width: auto;
        margin: var(--space);
    }

    .page__center-container{
        grid-column-start: 1;
        grid-column-end: 2;
    }

    .page__center-container.unauth {
        grid-column-start: 1;
        grid-column-end: 2;
    }

    .page__basic-info{
        margin: var(--space);
    }

    .page__experiences{
        margin: var(--space);
    }

    .page__center-container.adminview {
        grid-column-start: 1;
        grid-column-end: 2;
    }

    .page__center-container__tabs {
        margin-top: 0;
    }

    .page__left-container__info {
        margin: 0;
    }

    .MuiTabs-scroller.MuiTabs-fixed{
        overflow: scroll !important;
    }

    .page_tab_feed{
        width: 96%;
        margin-left: var(--space-half);
        margin-right: var(--space-half);
    }
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .page__right-container {
         display: none;
    }

    .page{
        display: block;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/views/PageView.styles.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,aAAa;IACb,2FAA2F;IAC3F,sCAAsC;IACtC,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,uIAAuI;AAC3I;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,oCAAoC;IACpC,sDAAsD;IACtD,yDAAyD;AAC7D;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,mCAAmC,CAAC,OAAO;IAC3C,sDAAsD,CAAC,SAAS;IAChE,uBAAuB;IACvB,gCAAgC;IAChC,oBAAoB;AACxB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,iCAAiC;AACrC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,mCAAmC;AACvC;AACA;IACI,6BAA6B;IAC7B,yCAAyC;AAC7C;AACA;IACI,6BAA6B;IAC7B,yCAAyC;AAC7C;;;AAGA,yCAAyC,4BAA4B;;IAEjE;QACI,mCAAmC;QACnC,oCAAoC;QACpC,2BAA2B;QAC3B,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,8BAA8B;QAC9B,+BAA+B;IACnC;AACJ;;AAEA,yCAAyC,4BAA4B;IACjE;SACK,aAAa;IAClB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["\n.page {\n    margin: 0 var(--space-x3);\n    display: grid;\n    grid-template-areas: \". left left left center center center center center center center . \";\n    grid-template-columns: repeat(12, 1fr);\n    gap: var(--space-and-half);\n    padding-bottom: var(--space-x3);\n}\n\n.page-admin__content{\n    /* width: 85%; */\n    margin: 0 auto;\n}\n\n.page-title {\n    position: absolute;\n    margin-top: var(--space-x2-and-half);\n    margin-left: calc((calc((calc((calc(100% - (calc(var(--space-x3)*2)) - (calc(11* var(--space-and-half)))))/12)) *2)) + var(--space-x3));;\n}\n\n.page__left-container {\n    grid-area: left;\n}\n\n.page__left-container__info {\n    margin: var(--space-x2-and-half) 0;\n}\n\n/* .page__right-container {\n    margin-top: var(--space-x2-and-half);\n    grid-area: right;\n    grid-column-start: 10;\n    grid-column-end: 13;\n} \n\n.page__right-container.adminview {\n    display: none;\n}\n.page__right-container__title {\n    margin-top: var(--space-x3);\n}\n.page__right-container__subtitle {\n    margin-top: var(--space-x2);\n}\n.page__right-container__profile-suggestions {\n    margin-top: var(--space-x2);\n}\n.page__right-container__pages-suggestions {\n    margin-top: var(--space-x2);\n} */\n\n.page__center-container {\n    grid-area: center;\n    grid-column-start: 2;\n    grid-column-end: 12;\n}\n\n.page__center-container.unauth {\n    grid-column-start: 3;\n    grid-column-end: 11;\n}\n\n.page__center-container.adminview {\n    grid-column-start: 3;\n    grid-column-end: 13;\n}\n.page__center-container__info-horizontal {\n    margin-top: calc(var(--space-x2-and-half));\n}\n.page__center-container__tabs {\n    background-color: var(--white-color);\n    border-top: 1px solid var(--new-gray-background-color);\n    border-bottom: 1px solid var(--new-gray-background-color);\n}\n\n.page__center-container__tabs .MuiTabs-flexContainer{\n    border-bottom: unset;\n}\n\n.page__center-container__tabs .MuiTab-wrapper {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + 1px);/*17px*/\n    line-height: calc(var(--space) + var(--space-quarter));/* 20px */\n    letter-spacing: 0.005em;\n    color: var(--primary-dark-color);\n    text-transform: none;\n}\n\n\n.page__center-container__tabs .MuiTabs-flexContainer .MuiButtonBase-root {\n    min-width: 100px;\n}\n\n.page__completion {\n    margin-top: var(--space-and-half);\n}\n.page__basic-info {\n    /* margin-top: var(--space-and-half); */\n}\n.page__technics {\n    margin-top: var(--space-and-half);\n}\n.page__skills {\n    margin-top: var(--space-and-half);\n}\n.page__experiences {\n    /* margin-top: var(--space-and-half); */\n}\n.page__aptitudes {\n    margin-top: var(--space-and-half);\n}\n\n.page_tab_feed{\n    width: 60%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.page__private-message {\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 70%;\n    text-align: center;\n}\n.page__private-message__icon {\n    margin-top: var(--space-x3);\n    color: var(--basic-gray-color);\n    font-size: var(--space-x2-and-half);\n}\np.page__private-message__title {\n    margin-top: var(--space-half);\n    color: var(--basic-gray-color) !important;\n}\np.page__private-message__subtitle {\n    margin-top: var(--space-half);\n    color: var(--basic-gray-color) !important;\n}\n\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .page {\n        margin: var(--space-and-half) 0 0 0;\n        grid-template-areas: \"left\" \"center\";\n        grid-template-columns: 100%;\n        gap: var(--space-half);\n    }\n    .page-admin__content {\n        width: auto;\n        margin: var(--space);\n    }\n\n    .page__center-container{\n        grid-column-start: 1;\n        grid-column-end: 2;\n    }\n\n    .page__center-container.unauth {\n        grid-column-start: 1;\n        grid-column-end: 2;\n    }\n\n    .page__basic-info{\n        margin: var(--space);\n    }\n\n    .page__experiences{\n        margin: var(--space);\n    }\n\n    .page__center-container.adminview {\n        grid-column-start: 1;\n        grid-column-end: 2;\n    }\n\n    .page__center-container__tabs {\n        margin-top: 0;\n    }\n\n    .page__left-container__info {\n        margin: 0;\n    }\n\n    .MuiTabs-scroller.MuiTabs-fixed{\n        overflow: scroll !important;\n    }\n\n    .page_tab_feed{\n        width: 96%;\n        margin-left: var(--space-half);\n        margin-right: var(--space-half);\n    }\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .page__right-container {\n         display: none;\n    }\n\n    .page{\n        display: block;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
